import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React, { useContext, useEffect, useRef, useState } from "react";
import { delimitationService } from "../../services/DelimitationService";
import { reportService } from "../../services/ReportService";
import Viewer, { Worker, defaultLayout } from "@phuocng/react-pdf-viewer";
import "@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css";
import { Dialog } from "primereact/dialog";
import ReportFilter from "./ReportFilter";
import { AppDB } from "../../App";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { helper } from "../../componets/utils/helper";

export const PrintOut = ({ base64 = "",isReport=false, setBase64 = () => { }, showDialog = false, setShowDialog = () => { } }) => {
    var [loading, setLoading] = useState(true)
    var [activeIndex, setActiveIndex] = useState(0)

    var { toast } = useContext(AppDB)


    const [bytePdf, setBytePdf] = useState(null);
    useEffect(() => {
        if (base64?.trim()?.length > 5) {
            var data = helper.base64ToFileUrl(base64)
            setBytePdf(data)
            setActiveIndex(1)
            if(isReport){
                 toast.show({ severity: "success", summary: "Success", detail: "Report Loaded", life: 8000 });
            }
           
        } else {
            setActiveIndex(0)
            // toast.show({ severity: "error", summary: "", detail: "No Data Found", life: 8000 });
        }
        setLoading(false);
    }, [base64])





    return (
        <div className="grid">
            <div className="col-12">
                <Dialog
                    draggable={false}
                    maximizable={false}
                    maximized
                    showHeader={false}
                    header={
                        <b >
                            <h5 >Report Preview</h5>
                        </b>
                    }
                    style={{ width: "75%", height: "75%" }}
                    modal
                    visible={base64?.trim()?.length > 5}
                    onHide={(e) => {
                        setBase64("")
                    }}
                    footer={
                        <>
                            <Button loading={loading} className="my-2  p-button-danger" label="Close" onClick={() => { setBase64("") }} icon="pi pi-times" />
                        </>
                    }
                >



                    <Worker workerUrl="script/pdf.worker.min.js">
                        <Viewer zoomInButton={true} defaultScale={1} onDocumentLoad={console.log} fileUrl={bytePdf} />

                    </Worker>

                </Dialog>
            </div>
        </div>
    );
};
